import { useState, useEffect } from 'react'
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from 'src/_metronic/helpers'

const SidebarFooter = () => {
  const [show, setShow] = useState(false)
  const [tooltipKey, setTooltipKey] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()

  const handleClose = () => {
    setShow(false)
    setTooltipKey(prev => prev + 1)
    const updatedPath = location.pathname.split('#')[0]
    navigate(-1)
  }

  const handleShow = () => {
    setShow(true)
    const updatedPath = `${location.pathname}#shortcut-model`
    navigate(updatedPath)
  }

  const renderTooltip = (props : any) => (
    <Tooltip id="button-tooltip" {...props}>
      Shortcuts
    </Tooltip>
  )

  // Show or hide modal based on URL hash
  useEffect(() => {
    if (location.hash === '#shortcut-model') {
      setShow(true)
    } else {
      setShow(false)
      setTooltipKey(prev => prev + 1)
    }
  }, [location.hash])

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <OverlayTrigger placement="top" key={tooltipKey} overlay={renderTooltip}>
        <Button variant='link' onClick={handleShow} className='btn-icon svg-icon-2 m-0 w-auto h-auto'>
          <i className="fas fa-question-circle fs-3"></i>
        </Button>
      </OverlayTrigger>

      <Modal show={show} onHide={handleClose} className='delete-model'>
        <Modal.Header closeButton>
          <Modal.Title>Shortcuts</Modal.Title>
          {/* <div
                  className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
                  style={{ zIndex: 99, top: "41px", marginLeft: "-65px" ,width: "34px",
                    height: "32px"}}
                  role="button"
                  aria-label="Go back to previous page"
                  tabIndex={0}
                  data-tooltip="Back"
                  onClick={() => navigate(-1)}
                >
                  <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
                </div> */}
        </Modal.Header>
        <Modal.Body>
          <img src={toAbsoluteUrl('/media/shortcut.png')} alt='Documentation' className='img-fluid' />
          {/* <div
        className='btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary bg-white h-30px w-30px position-absolute start-100 translate-middle'
        style={{zIndex: 99, top: '33px',marginLeft: '-34px'}}

        onClick={() => navigate(-1)}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr079.svg' className='svg-icon-2' />
      </div> */}
          <div className='text-end'>
            <Button variant='text' onClick={handleClose} className='text-primary py-0 px-0 mt-6'>
              Close
            </Button>
            
          </div>
         
        </Modal.Body>
      </Modal>
    </div>
  )
}

export { SidebarFooter }